import React from 'react';
import NavigationMenu from './NavigationMenu';
import buildNavItem from '../../../utils/NavItemBuilder';
import config from '../../../config';

export default class BottomMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: []
        };
    }

    componentWillMount() {
        this.buildItems(this.props);
    }

    buildItems(props) {
        let items = [
            buildNavItem({href:'/team', text:'Екип'}),
            buildNavItem({href: config.blogUrl, text:'Блог'}),
            buildNavItem({href:'/contacts', text:'Контакти'})
        ];

        this.setState({items});
    }

    componentWillReceiveProps(newProps) {
        this.buildItems(newProps);
    }

    render() {
        return <NavigationMenu className={this.props.className} items={this.state.items} />
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/BottomMenu.js